<template>
  <!-- LS 表示绿瘦集团定制样式 -->
  <div :class="['Dkb', {'LS': $route.meta.LSS}]">
    <DkbBar />
    <!-- 数据中心 -->
    <div class="mainDkb">
      <keep-alive include="DkbSScreen">
        <router-view></router-view>
      </keep-alive>
      <GM class="GM" />
    </div>
    <!-- 底部栏 -->
    <div class="footerBar">
      <p class="datetime">
        <span class="text">{{realTime.date}}</span>
        <span class="text">{{realTime.week}}</span>
        <span class="text">{{realTime.time}}</span>
      </p>
      <p v-if="$route.meta.LSS" class="support">{{ company_name }}</p>
      <p v-else class="support">极酷物联提供技术支持</p>
    </div>
  </div>
</template>

<script>
import DkbBar from "@/components/DkbPage/Layout/DkbBar"; // 标题栏
import GM from "@/components/DkbPage/GM/GM"; // 通用模块
import {
  localUserInfo,
  showToast,
} from "../../../static/js/utility/utility.js";
let vm, timeInterval;

export default {
  name: "Dkb",
  components: {
    DkbBar,
    GM,
  },
  data() {
    return {
      realTime: {},
    };
  },
  computed: {},
  created() {
    vm = this;
    vm.company_name = localUserInfo.getItem().company_name
    timeInterval = setInterval(() => {
      this.getNowTime();
    }, 1000);
  },
  mounted() {
    document.body.style.scrollbarArrowColor = "green";
    // console.log('route', this.$route)
  },
  destroyed() {
    clearInterval(timeInterval);
  },
  methods: {
    getNowTime() {
      let nDate = new Date();
      let date =
        nDate.getFullYear() +
        "-" +
        (nDate.getMonth() + 1) +
        "-" +
        nDate.getDate();
      let weekLabel = [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ];
      let week = weekLabel[nDate.getDay() - 1];
      let hour =
        nDate.getHours() < 10 ? "0" + nDate.getHours() : nDate.getHours();
      let minute =
        nDate.getMinutes() < 10 ? "0" + nDate.getMinutes() : nDate.getMinutes();
      let second =
        nDate.getSeconds() < 10 ? "0" + nDate.getSeconds() : nDate.getSeconds();
      let time = hour + ":" + minute + ":" + second;
      vm.realTime = { date, week, time };
      // console.log('当前时间：', date, week, time)
    },
  },
  watch: {},
};
</script>

<style lang="scss">
$DkbBarHeight: 1.13rem; // DkbBar高度
$footerHeight: 0.58rem; // footerBar高度
$footerMT: 0.28rem; // footerBar上边距
.Dkb {
  width: 100%;
  height: 100vh;
  background: url("/static/images/dkb/bg.png") center no-repeat;
  background-size: cover;
  padding: 0 0.39rem 0 0.37rem;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  .mainDkb {
    width: 100%;
    height: calc(100% - 0.86rem - 1.13rem);
    display: flex;
    justify-content: space-between;
  }
  .DkbBar {
    flex-shrink: 0;
    width: 100%;
    height: $DkbBarHeight;
  }
  .footerBar {
    flex-shrink: 0;
    width: 18.44rem;
    height: $footerHeight;
    margin-top: $footerMT;
    font-size: 0.2rem;
    color: #6cc4bd;
    background: url("/static/images/dkb/footer_bg.png") top center no-repeat;
    background-size: 18.38rem 0.35rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    // position: fixed;
    // bottom: 0;
    // left: 0.37rem;
    .datetime {
      padding-left: 0.37rem;
      .text {
        margin-right: 0.26rem;
        letter-spacing: 0.02rem;
      }
    }
    .support {
      letter-spacing: 0.07rem;
      margin-right: 0.27rem;
    }
    .DkbPaging {
      width: 3.75rem;
      // text-align: center;
      display: flex;
      justify-content: center;
      position: absolute;
      left: 4.24rem;
      top: 0.13rem;
      .li {
        height: 0.26rem;
        line-height: 0.26rem;
        padding: 0 0.06rem;
        font-size: 0.2rem;
        color: #7da4c8;
      }
      .li + .li {
        margin-left: 0.15rem;
      }
      .li.active {
        line-height: 0.23rem;
        border: 0.01rem solid #7da4c8;
        box-shadow: 0 0 0.03rem rgba(123, 159, 195, 0.41);
      }
      .li.ico {
        font-size: 0.18rem;
      }
    }
  }
}

// 绿瘦集团定制样式
.Dkb.LS {
  .GM {
    background: none;
    box-shadow: none;
    .GMContent {
      .warningArea {
        margin-top: 0.35rem;
        height: 2.73rem;
        background: url("/static/images/dkb/NARA/ls/warning_bg.png") center
          no-repeat;
        background-size: 5.06rem 100%;
        &.has {
          background: url("/static/images/dkb/NARA/ls/warning_bg_ing.png")
            center no-repeat;
          background-size: 5.06rem 100%;
        }
      }
    }
  }
  .DkbFScreen {
    background: none;
    // 全屏标题
    .fsTit {
      margin-left: 0.55rem;
      box-shadow: rgba(0, 0, 0, 0.2) 0 0 0.31rem;
      background: url(/static/images/dkb/NARA/ls/fsTit_bg.png) center no-repeat;
      background-size: 2.44rem 0.35rem;
    }
    .DkbFNARA {
      .topArea {
        .sideArea::before {
          background: url(/static/images/dkb/NARA/ls/side_icon.png) center
            no-repeat;
          background-size: 100%;
        }
      }
    }
  }
  .footerBar {
    background: url("/static/images/dkb/NARA/ls/footer_bg.png") top center
      no-repeat;
  }
}

// 数据看板滚动条样式
.DkbScroll::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0.13rem; /*高宽分别对应横竖滚动条的尺寸*/
  padding: 0.13rem 0;
  // scrollbar-arrow-color:red;
}
.DkbScroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  box-shadow: inset 0 0 0.03rem rgba(255, 255, 255, 0.13);
  -webkit-box-shadow: inset 0 0 0.03rem rgba(255, 255, 255, 0.13);
  border: 0.01rem solid #1b3f60;
  box-sizing: border-box;
  background: #093053;
}
.DkbScroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: #072a4b;
}
// ::-webkit-scrollbar-button {
// }
.DkbScroll::-webkit-scrollbar-button:vertical:start {
  background: #072a4b url("/static/images/dkb/icon_scroller_t.png") center
    no-repeat;
  background-size: 0.1rem 0.05rem;
}
.DkbScroll::-webkit-scrollbar-button:vertical:end {
  background: #072a4b url("/static/images/dkb/icon_scroller_b.png") center
    no-repeat;
  background-size: 0.1rem 0.05rem;
}
.DkbScroll {
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #134187;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #134187;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #011433;

  scrollbar-base-color: #134087;
  //scrollbar-base-color: #134087;
  scrollbar-3dlight-color: #134087;
  scrollbar-highlight-color: #134087;
  scrollbar-track-color: #011433;
  scrollbar-arrow-color: #011433;
  scrollbar-shadow-color: #011433;
  //scrollbar-dark-shadow-color: #011433;
}
// 单行溢出
.one-line-overhidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/Dkb.vue